'use client';
import type React from 'react';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useApp } from '@/forApp/states/appState/appState';
import fetcher from '@/forApp/utils/fetcher/fetcher';
import Button from '@/shared/Buttons/Button';
import Input from '@/shared/Input/input';
import styles from '../login/styles.module.css';

interface ForgotFormData {
  email: string;
}

const ForgotPassword: React.FC = () => {
  const { delModal, addNotification } = useApp();
  const [isLoading, setIsLoading] = useState(false);

  const {
    control,
    handleSubmit,
    formState: { isValid },
  } = useForm<ForgotFormData>({
    defaultValues: { email: '' },
    mode: 'onChange',
  });

  const onSubmit = async (data: ForgotFormData) => {
    setIsLoading(true);
    try {
      await fetcher<unknown>('POST', '/forgot-password', {
        body: JSON.stringify({ email: data.email }),
      });

      // Some backends return a message; the fetcher already toasts errors.
      addNotification({
        text: 'Ссылка для восстановления отправлена на почту, если её нет, проверьте папку СПАМ ',
        type: 'success',
      });
      delModal();
    } catch {
      // Errors are handled in fetcher via notifications
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.loginForm}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <h1>Восстановление пароля</h1>
        <div className={styles.formField}>
          <Input
            name="email"
            control={control}
            type="email"
            placeholder="E-mail"
            rules={{
              required: 'Email обязателен',
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: 'Некорректный email',
              },
            }}
            autocomplete="email"
          />
        </div>

        <div className={styles.btnWrapper}>
          <Button
            type="submit"
            text={isLoading ? 'Отправка...' : 'Отправить'}
            disabled={!isValid || isLoading}
            isLoading={isLoading}
          />
        </div>
      </form>
    </div>
  );
};

export default ForgotPassword;
